import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { handleChangeDataModalTransDetails } from '../../../../redux/actions/partials/modals/modalTransDetails'


const ModalTransDetails = (props) => {

	const dispatch = useDispatch();

	const { isOpen, data } = useSelector(state => state.modalTransDetails);

	const handleClose = () => {
        dispatch(handleChangeDataModalTransDetails('isOpen', false));
    };    

    return (
        <Modal show={isOpen} onHide={handleClose} className={`modal fade text-xs-left ${isOpen ? 'in' : ''}`} dialogClassName='modal-dialog modal-dialog-centered modal-fullscreen-sm-down' >
        	<div className="modal-dialog modal-lg" role="document" style={{marginTop: '0', marginBottom: '0'}}>
        		<div className="modal-content">
        			<div className="modal-header">
		                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
		                    <span aria-hidden="true">&times;</span>
		                </button>
		                <h4 className="modal-title" id="myModalLabel17">جزئیات تراکنش</h4>
		            </div>
		            <div className="modal-body">
		                <div className="row">
		                    <div className="col-md-4">
		                        <div className="card border-gray border-lighten-1" style={{minHeight: 'unset !important'}} >
		                            <div className="p-1">
		                                <p className="mb-0">
		                                    <small className="text-muted">نام فروشگاه</small>
		                                </p>
		                                <p className="mb-0" id="modal-shop-name">
		                                    {data.shop_name}
		                                </p>
		                            </div>
		                        </div>
		                    </div>
		                    <div className="col-md-4">
		                        <div className="card border-gray border-lighten-1" style={{minHeight: 'unset !important'}} >
		                            <div className="p-1">
		                                <p className="mb-0">
		                                    <small className="text-muted">متصدی فروشگاه</small>
		                                </p>
		                                <p className="mb-0" id="modal-operator-name">
		                                    {data.operator_name}
		                                </p>
		                            </div>
		                        </div>
		                    </div>
		                    <div className="col-md-4">
		                        <div className="card border-gray border-lighten-1" style={{minHeight: 'unset !important'}} >
		                            <div className="p-1">
		                                <p className="mb-0">
		                                    <small className="text-muted">تاریخ تراکنش</small>
		                                </p>
		                                <p className="mb-0" id="modal-reg-date">
		                                    {data.reg_date}
		                                </p>
		                            </div>
		                        </div>
		                    </div>
		                </div>
		                <div className="row">
		                    <div className="col-md-4">
		                        <div className="card border-gray border-lighten-1" style={{minHeight: 'unset !important'}} >
		                            <div className="p-1">
		                                <p className="mb-0">
		                                    <small className="text-muted">مبلغ تراکنش</small>
		                                </p>
		                                <p className="mb-0" id="modal-trans-amount">
		                                    {parseInt(data.cart_amount_with_discount).toLocaleString()}
		                                </p>
		                            </div>
		                        </div>
		                    </div>
		                    <div className="col-md-4">
		                        <div className="card border-gray border-lighten-1" style={{minHeight: 'unset !important'}} >
		                            <div className="p-1">
		                                <p className="mb-0">
		                                    <small className="text-muted">سهم فروشگاه جهت تسویه</small>
		                                </p>
		                                <p className="mb-0" id="modal-shop_share-amount">
		                                    {parseInt(data.shop_share_amount).toLocaleString()}
		                                </p>
		                            </div>
		                        </div>
		                    </div>
		                    <div className="col-md-4">
		                        <div className="card border-gray border-lighten-1" style={{minHeight: 'unset !important'}} >
		                            <div className="p-1">
		                                <p className="mb-0">
		                                    <small className="text-muted">مبلغ برگشت وجه مشتری</small>
		                                </p>
		                                <p className="mb-0" id="modal-cash-back-amount">
		                                    {parseInt(data.cash_back_amount).toLocaleString()}
		                                </p>
		                            </div>
		                        </div>
		                    </div>
		                </div>
		                <div className="row">
		                    <div className="col-md-4">
		                        <div className="card border-gray border-lighten-1" style={{minHeight: 'unset !important'}} >
		                            <div className="p-1">
		                                <p className="mb-0">
		                                    <small className="text-muted">شماره پیگیری</small>
		                                </p>
		                                <p className="mb-0" id="modal-tracking-num">
		                                    {data.tracking_num}
		                                </p>
		                            </div>
		                        </div>
		                    </div>
		                    <div className="col-md-4">
		                        <div className="card border-gray border-lighten-1" style={{minHeight: 'unset !important'}} >
		                            <div className="p-1">
		                                <p className="mb-0">
		                                    <small className="text-muted">شماره فاکتور فروشگاه</small>
		                                </p>
		                                <p className="mb-0" id="modal-factor-num">
		                                    {data.factor_num}
		                                </p>
		                            </div>
		                        </div>
		                    </div>
		                    <div className="col-md-4">
		                        <div className="card border-gray border-lighten-1" style={{minHeight: 'unset !important'}} >
		                            <div className="p-1">
		                                <p className="mb-0">
		                                    <small className="text-muted">توضیحات</small>
		                                </p>
		                                <p className="mb-0" id="modal-description">
		                                    {data.description}
		                                </p>
		                            </div>
		                        </div>
		                    </div>
		                </div>
		            </div>
		            <div className="modal-footer">
		                <button type="button" className="btn grey btn-outline-secondary" data-dismiss="modal" onClick={handleClose}>بستن</button>
		            </div>
        		</div>
        	</div>

        </Modal>
    );
}

export default ModalTransDetails;
